import { Slide } from "react-reveal";

const HomeWhy = () => {
  return (
    <section className="painting-brush-bg section-spacing-80">
      <div className="container">
        <div className="large">
          <div className="section-content-container">
            <div className="section-head width-600 margin-auto">
              <Slide top>
                <h2 className="section-title">
                  <span className="flexi-magenta">Why</span> Flexi Painters
                </h2>
              </Slide>
              <p className="section-subtitle flexi-gold">
                At Flexi Painters, painting is more than applying color - it is
                about protecting your investment, enhancing your property's
                appearance and delivering finishes that impress and last.
              </p>
            </div>
            <div className="section-body section-spacing-20 width-600 margin-auto">
              <div className="why-lists">
                <ul className="why-list-container">
                  <li>
                    <h3>✔︎ Precision in every finish</h3>
                    <p>
                      We pay attention to every detail, from surface preparation
                      to the final coat ensuring clean lines, smooth finishes
                      and consistent quality through out the project{" "}
                    </p>
                  </li>
                  <li>
                    <h3>✔︎ Clean & professional work</h3>
                    <p>
                      We respect clients' properties. Our team maintains clean
                      work areas, protects sorrounding surfaces and leaves your
                      space neat and organized upon project completion
                    </p>
                  </li>
                  <li>
                    <h3>✔︎ Reliable project delivery</h3>
                    <p>
                      We value your time. Our projects are carefully planned and
                      executed within agreed timelines, ensuring minimal
                      disruption and dependable service
                    </p>
                  </li>
                </ul>
                <ul className="why-list-container">
                  <li>
                    <h3>✔︎ Quality materials & proven techniques</h3>
                    <p>
                      We use trusted paint brands, quality materials and
                      industry best practices to achieve durable, attractive and
                      long lasting results.
                    </p>
                  </li>
                  <li>
                    <h3>✔︎ Trained & experienced team</h3>
                    <p>
                      Our painters are professionally skilled and experienced to
                      commit to maintaining the highest standards of workmanship
                      across residential and commercial projects
                    </p>
                  </li>
                  <li>
                    <h3>✔︎ Clear communication & accountability</h3>
                    <p>
                      From quotation to completion, we keep you informed every
                      step of the way. We believe in transparency,
                      profesionalism and standing behind our work.
                    </p>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HomeWhy;
